<template>
    <div v-if="showDialog"
        class="body">
        <div class="content">
            <!-- 顶部图片 -->
            <img :src="img">
            <!-- 弹窗内容 -->
            <div class="pause-text">{{ text }}</div>
        </div>
    </div>
</template>
<script lang="js">
export default {
   props:{
    showDialog:{
        type:Boolean,
        default:false
    },
    img:String,
    text:String
   },
   data(){
       return{}
   }
};
</script>
<style lang="scss" scoped>
.body {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
}
.content {
  width: 76.4%;
  max-height: 250px;
  min-height: 150px;
  display: flex;
  justify-content: center;
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  align-items: center;
  height: 36vw;
  img {
    width: 50%;
    position: absolute;
    top: -20vw;
  }
}
.pause-text {
  margin-top: 5vw;
  font-size: 18px;
  color: #000000;
  text-align: center;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/modal/suspend-dialog.vue